import moment from 'moment';

export default class ReferenceHelpers {

    static CustomerTypes = [
        { value: 'Domestic', text: 'Domestic' },
        { value: 'Business', text: 'Business' }
    ];
    
    static Months = [
        { value: 1,  text: 'Jan' },
        { value: 2,  text: 'Feb' },
        { value: 3,  text: 'Mar' },
        { value: 4,  text: 'Apr' },
        { value: 5,  text: 'May' },
        { value: 6,  text: 'Jun' },
        { value: 7,  text: 'Jul' },
        { value: 8,  text: 'Aug' },
        { value: 9,  text: 'Sep' },
        { value: 10, text: 'Oct' },
        { value: 11, text: 'Nov' },
        { value: 12, text: 'Dec' },
    ];

    static CustomerCommTypes = [
        { id: 'Call', name: 'Call' },
        { id: 'Email', name: 'Email' },
        { id: 'SMS', name: 'SMS' },
        { id: 'Card', name: 'Card' },
        { id: 'Note', name: 'Note' }
    ];

    static OldCustomerCommResults = [
        { id: 'NoAnswer', name: 'No answer (no voicemail)', icon: 'fa-solid fa-times' },
        { id: 'WillCallUs', name: 'Will call us when ready', icon: 'fa-solid fa-times' },
        { id: 'Voicemail', name: 'Left voicemail', icon: 'fa-solid fa-times' },
        { id: 'Rescheduled', name: 'Rescheduled', icon: 'fa-solid fa-times' },
        { id: 'CouldntConnect', name: 'Couldn\'t connect', icon: 'fa-solid fa-times' },
        { id: 'AppointmentBooked', name: 'Appointment booked', icon: 'fa-solid fa-check' }
    ];
    
    static CustomerCommResults = [
        { id: 'AppointmentBooked', name: 'Appointment booked', icon: 'fa-solid fa-check' },
        { id: 'NoCookerAtProperty', name: 'No cooker at property', icon: 'fa-solid fa-times' },
        { id: 'CalledNoAnswer', name: 'Called no answer', icon: 'fa-solid fa-times' },
        { id: 'CalledLeftVoiceMail', name: 'Called left voice mail', icon: 'fa-solid fa-times' },
        { id: 'EmailSent', name: 'Email sent', icon: 'fa-solid fa-times' },
        { id: 'CardSent', name: 'Card sent', icon: 'fa-solid fa-times' }
    ];
    
    static OldAndNewCustomerCommResults = [
        { id: 'NoAnswer', name: 'No answer (no voicemail)', icon: 'fa-solid fa-times' },
        { id: 'WillCallUs', name: 'Will call us when ready', icon: 'fa-solid fa-times' },
        { id: 'Voicemail', name: 'Left voicemail', icon: 'fa-solid fa-times' },
        { id: 'Rescheduled', name: 'Rescheduled', icon: 'fa-solid fa-times' },
        { id: 'CouldntConnect', name: 'Couldn\'t connect', icon: 'fa-solid fa-times' },
        { id: 'AppointmentBooked', name: 'Appointment booked', icon: 'fa-solid fa-check' },
        { id: 'NoCookerAtProperty', name: 'No cooker at property', icon: 'fa-solid fa-times' },
        { id: 'CalledNoAnswer', name: 'Called no answer', icon: 'fa-solid fa-times' },
        { id: 'CalledLeftVoiceMail', name: 'Called left voice mail', icon: 'fa-solid fa-times' },
        { id: 'EmailSent', name: 'Email sent', icon: 'fa-solid fa-times' },
        { id: 'CardSent', name: 'Card sent', icon: 'fa-solid fa-times' }
    ]

    static PaymentTypes = [
        { id: 'PayNow', name: 'Pay balance now' },
        { id: 'PaymentToFollow', name: 'Payment to follow' },
        { id: 'SendInvoice', name: 'Send invoice' }
    ];

    // Durations in minutes (15 minute increments)
    static Durations = [
        15, 30, 45, 60, 75, 90, 105, 120, 135, 150, 165, 180, 195, 210, 225, 240, 255, 270, 285, 300, 315, 330, 345, 360, 375, 390, 405, 420, 435, 450, 465, 480, 495, 510, 525, 540, 555, 570, 585, 600, 615, 630, 645, 660, 675, 690, 705, 720, 735, 750, 765, 780, 795, 810, 825, 840, 855, 870, 885, 900, 915, 930, 945, 960, 975, 990, 1005, 1020, 1035, 1050, 1065, 1080, 1095, 1110, 1125, 1140, 1155, 1170, 1185, 1200, 1215, 1230, 1245, 1260
    ];

    static listTimes() {
        const times = [];
        let hours = 0;
        let minutes = 0;
        while (hours < 24) {
            const formattedHours = hours < 10 ? `0${hours}` : `${hours}`;
            const formattedMinutes = minutes === 0 ? '00' : `${minutes}`;
            const time = `${formattedHours}:${formattedMinutes}`;
            times.push(time);
            minutes += 15;
            if (minutes >= 60) {
                minutes -= 60;
                hours++;
            }
        }
        return times;
    }

    static formatNotification(notification) {
        let msg = moment(notification.dateTime).format('DD/MM/YYYY');
        if (msg == '01/01/2000') {
            msg = 'Old system';
        }
        msg += ': ';
        switch (notification.type) {
            case 'ApptBooked':
                msg += `Booked`;
                break;
            case 'ApptCompleted':
                msg += `Completed`;
                break;
            case 'ApptReminder':
                msg += `Reminder, `;
                msg += (notification.numDays == 1 ? '1 day' : notification.numDays + ' days') + ' ahead';
                break;
        } 
        if (notification.customerComms.length > 0) {
            msg += ` (${notification.customerComms.map(cc => cc.type).join(', ')})`;
        }
        return msg;
    };

    static getTravelTimeColour(travelTime, settings) {
        if (!travelTime || !settings.travelTimeGreen || !settings.travelTimeRed) {
            return '#FF00FF'; // Magenta - not set up properly 
        }
        if (travelTime <= settings.travelTimeGreen) {
            return '#00C800'; // Green
        }
        else if (travelTime < settings.travelTimeRed) {
            return '#ff8000'; // Orange
        } else {
            return '#C80000'; // Red
        }
    }

}